module.exports = "<mos>\n\t<mosID>aircache.newscenter.com</mosID>\n\t<ncsID>ncs.newscenter.com</ncsID>\n\t<messageID/>\n\t<ncsAppInfo>\n\t\t<ncsInformation>\n\t\t\t<userID>DEMO</userID>\n\t\t\t<runContext>BROWSE</runContext>\n\t\t</ncsInformation>\n\t</ncsAppInfo>\n</mos>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/Test/ContainerTest/mosTemplate/ncsAppInfo.xml
// module id = 1298
// module chunks = 0